// flights_currency_selection_with_pos_switch

import { useCallback } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";

const utils = createMicroConversionTrackingUtils({
  name: "flights_currency_selection_with_pos_switch",
  stages: {
    main: 1,
    visitors_see_flights_header: 2,
    visitors_have_currency_selected: 3,
    ddot: 4,
    mdot: 5
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {
    currencySelectionPickerClick: 1, // track in remote header component
    currencySelected: 2, // track in remote header component
    currencySelectedOverrideIpCountry: 3
  },
  goalsWithValue: []
});

export const useTrackCurrencySelectionWithPosSwitch = () => {
  const { isDesktop, isMobile } = useProfiler();

  const trackCurrencySelectionWithPosSwitch = useCallback(() => {
    if (isMobile()) {
      // Exclude mdot from flights_apps_currency_selection_with_pos_switch
      if (isFeatureRunningClientSide("FLIGHTS_PRICING_EXCLUDE_MDOT_FOR_CURRENCY_SELECTION")) {
        return false;
      }
      utils.stages.mdot();
    }

    isDesktop() && utils.stages.ddot();

    return !!utils.trackWithDefaultStage();
  }, [isDesktop, isMobile]);

  return { trackCurrencySelectionWithPosSwitch };
};

export default { ...utils };
